import { DynamicIcon } from '../../atoms/Icons'
import { MenuItemProps } from 'interfaces/menu'

interface MenuItemWithCollapse extends MenuItemProps {
    icon?: string
    isCollapsed?: boolean
    isLastItem?: boolean
}

const MenuItem = ({
    title,
    url,
    onClick,
    active,
    icon,
    isCollapsed = false,
    isLastItem = false,
}: MenuItemWithCollapse) => {
    return (
        <div
            className={`w-full flex items-center  px-4 py-2.5 rounded-lg transition-colors  ${
                isCollapsed ? 'px-2 justify-center' : 'justify-center gap-2'
            } ${
                active
                    ? 'bg-neutral-100 '
                    : `text-gray-700 ${!isLastItem ? 'hover:bg-[#F1F5F9]' : ''}`
            }`}
            title={isCollapsed ? title : undefined}
        >
            <a
                href="#"
                onClick={(e) => {
                    e.preventDefault()
                    onClick && onClick(url)
                }}
                className={`${isCollapsed ? '' : 'flex flex-1'} font-medium text-sm items-center gap-2`}
            >
                {icon && (
                    <span
                        className={`flex-shrink-0 ${active ? `text-black ${isCollapsed ? 'w-full flex' : ''}` : `text-gray-500 ${isCollapsed ? 'w-full justify-center flex' : ''}`}`}
                    >
                        <DynamicIcon
                            name={icon}
                            className={isCollapsed ? 'w-4 h-4' : ''}
                        />
                    </span>
                )}
                {!isCollapsed && title}
            </a>

            {isCollapsed && (
                <button
                    onClick={() => {
                        onClick && onClick(url)
                    }}
                    className="flex-1"
                    aria-label={title}
                />
            )}
        </div>
    )
}

export default MenuItem
